import {Stack, Text} from '@mantine/core';
import type {FC, ReactNode} from 'react';

/**
 * Unboxed metric: a large value with a small dimmed label beneath it, no border or icon —
 * for a stat row inside a card that already provides its own container.
 * @registry Unboxed value-over-label stat for hero/summary card stat rows.
 */
export interface InlineStatProps {
  /** Primary metric text — a count, short date, or free text. Wraps, never truncates. */
  value: ReactNode;
  /** Base label, e.g. "Devices". */
  label: string;
  /** Optional qualifier appended after a "·" separator, e.g. "2 buildings" appended to "Floors". */
  labelDetail?: string;
}

export const InlineStat: FC<InlineStatProps> = ({value, label, labelDetail}) => (
  <Stack gap={2}>
    <Text fz={28} fw={700} lh={1.2} style={{wordBreak: 'break-word'}}>
      {value}
    </Text>
    <Text fz="xs" fw={500} c="dimmed">
      {labelDetail ? `${label} · ${labelDetail}` : label}
    </Text>
  </Stack>
);
